import { SearchParams, TextTag, Range } from './types';
import { FIELDS, FIELDS_BY_KEY, defaultParams } from './fields';
import { readAddedItems, readRange } from './dom-helpers';

let params: SearchParams = defaultParams();

function persist(): void {
  $('#audience_search_params').val(JSON.stringify(params));
}

export function updateSearchParams(): SearchParams {
  $('.filter-row[data-filter]').each(function() {
    const $row = $(this);
    const key = $row.data('filter') as keyof SearchParams;
    const field = FIELDS_BY_KEY[key];
    if (!field) return;

    switch (field.kind) {
      case 'text-tags':
        (params[field.key] as TextTag[]) = readAddedItems($row).map(({ text, filter }) => ({ text, filter }));
        break;
      case 'string-array':
        (params[field.key] as string[]) = readAddedItems($row).map(({ text }) => text);
        break;
    }
  });

  persist();
  return params;
}

export function commitField($row: JQuery): void {
  const key = $row.data('filter') as keyof SearchParams;
  const field = FIELDS_BY_KEY[key];
  if (!field) return;

  if (field.kind === 'keywords') {
    params.keywords = String($row.find('[data-keywords]').val() ?? '').trim();
  } else if (field.kind === 'range') {
    const range = readRange($row);
    const fallback = defaultParams()[field.key] as Range;
    (params[field.key] as Range) = {
      min: range.min,
      max: range.max ?? fallback.max,
    };
  }

  persist();
}

export function clearField($row: JQuery): void {
  const key = $row.data('filter') as keyof SearchParams;
  const field = FIELDS_BY_KEY[key];
  if (!field) return;

  if (field.kind === 'keywords') {
    params.keywords = '';
  } else if (field.kind === 'range') {
    (params[field.key] as Range) = { min: null, max: null };
  }

  persist();
}

export function resetSearchParams(): void {
  params = defaultParams();
  persist();
}

export function audienceParamsForSave(source: SearchParams): Partial<SearchParams> {
  const out: Partial<SearchParams> = { ...source };
  FIELDS.filter(field => field.kind === 'range').forEach(field => {
    const committed = $(`.filter-row[data-filter="${field.key}"] .ads-pool-added-items .ads-pool-added-item`).length > 0;
    if (!committed) delete out[field.key];
  });
  return out;
}
